import * as React from 'react';
import { Config } from './helper';
import { fetchCollection } from './api';

export function useCollection(collectionID) {
  const [state, setState] = React.useState(Config.State.initial);
  const [collection, setCollection] = React.useState(null);

  React.useEffect(() => {
    if (!collectionID) {
      setState(Config.State.failed);
      return;
    }

    let cancelled = false;

    fetchCollection(collectionID)
      .then(data => {
        if (cancelled) return;
        setCollection(data);
        setState(Config.State.loaded);
      })
      .catch(() => {
        if (cancelled) return;
        setState(Config.State.failed);
      });

    return () => { cancelled = true; };
  }, [collectionID]);

  const pathways = React.useMemo(
    () => collection?.learning_pathways || [],
    [collection]
  );

  const scores = React.useMemo(() => Object.fromEntries(
    pathways.map(p => [p.id, { earned: p.earned_score || 0, max: p.max_score || 0 }])
  ), [pathways]);

  const progress = React.useMemo(() => {
    const totals = pathways.reduce((acc, p) => {
      acc.earned += p.earned_score || 0;
      acc.max += p.max_score || 0;
      return acc;
    }, { earned: 0, max: 0 });
    return totals.max > 0 ? (totals.earned / totals.max) * 100 : 0;
  }, [pathways]);

  return { state, collection, pathways, scores, progress };
}
